import React from 'react';
import { motion } from 'framer-motion';
import { services } from '../../data/portfolioData';
import { 
  CheckSquare, 
  FileText, 
  Gavel, 
  TrendingUp, 
  Users, 
  Truck, 
  Heart 
} from 'lucide-react';

const Services: React.FC = () => {
  const getServiceIcon = (iconName: string) => {
    switch (iconName) {
      case 'check-square':
        return <CheckSquare size={32} />;
      case 'file-text':
        return <FileText size={32} />;
      case 'gavel':
        return <Gavel size={32} />;
      case 'trending-up':
        return <TrendingUp size={32} />;
      case 'users':
        return <Users size={32} />;
      case 'truck':
        return <Truck size={32} />;
      case 'heart':
        return <Heart size={32} />;
      default:
        return <CheckSquare size={32} />;
    }
  };

  return (
    <section id="services" className="services">
      <div className="container">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          Services
        </motion.h2>
        
        <div className="services-grid">
          {services.map((service, index) => (
            <motion.div
              key={service.id}
              className="service-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ y: -8 }}
            >
              <div className="service-icon">
                {getServiceIcon(service.icon)}
              </div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
